<template>
    <div class="card">
        <div class="card-header d-flex justify-content-between">
            <div>{{ $t("products.bundles.editor.header") }}</div>
            <button
                class="btn btn-sm btn-secondary"
                type="button"
                :disabled="saving || (theBundle && !theBundle.id)"
                @click="createNewBundle"
            >
                {{ $t("products.bundles.editor.button_create") }}
            </button>
        </div>

        <div class="card-body">
            <div v-if="bundles !== null" class="row">
                <div
                    class="col-md-4"
                    style="max-height: 90vh; overflow-y: auto"
                >
                    <ul
                        class="d-flex flex-column justify-content-center mb-3 pl-0"
                    >
                        <li
                            v-for="bundle in bundles"
                            :key="bundle.id"
                            class="d-flex justify-content-between align-items-center mb-3"
                        >
                            <div>
                                <h6 class="my-0 font-weight-bold">
                                    {{ bundle.name }}
                                    <small>(id: {{ bundle.id }})</small>
                                </h6>
                                <small
                                    >{{
                                        bundle.products.length
                                    }}
                                    produkter</small
                                >
                            </div>
                            <button
                                class="btn btn-sm btn-secondary ml-3"
                                type="button"
                                :disabled="saving || theBundle === bundle"
                                @click="editBundle(bundle)"
                            >
                                {{ $t("products.bundles.editor.button_edit") }}
                            </button>
                        </li>
                    </ul>
                </div>
                <div class="col">
                    <products-bundle-form
                        v-if="theBundle"
                        :bundle="theBundle"
                        @updated="onUpdated($event)"
                    ></products-bundle-form>
                </div>
            </div>
            <SbSpinner v-else></SbSpinner>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import axios from "axios";
import ProductsBundleForm from "./_form.vue";
import { route } from "ziggy";
const props = defineProps({});
const bundles = ref(null);
const theBundle = ref(null);
const saving = ref(false);
const errorMessage = ref(null);
const successMessage = ref(null);
function editBundle(bundle) {
  if (theBundle.value === bundle) {
    return;
  }
  theBundle.value = bundle;
  errorMessage.value = null;
  successMessage.value = null;
}
function createNewBundle() {
  editBundle({
    id: null
  });
}
function onUpdated(bundle) {
  bundles.value = bundles.value.filter(b => b.id !== bundle.id);
  bundles.value.push(bundle);
  bundles.value.sort((a, b) => a.name.localeCompare(b.name));
  theBundle.value = null;
}
onMounted(async () => {
  const loadedBundles = [];
  let nextUrl = route("products.bundles.index");
  while (nextUrl) {
    let response = await axios.get(nextUrl);
    loadedBundles.push(...response.data.data);
    nextUrl = response.data.links.next;
  }
  bundles.value = loadedBundles.sort((a, b) => a.name.localeCompare(b.name));
});
</script>
